import PropTypes from 'prop-types'

import MoleculeNotification, {
  AUTO_CLOSE as moleculeNotificationAutoClose,
  TYPES as moleculeNotificationTypes
} from '@s-ui/react-molecule-notification'

const BASE_CLASS = 'mt-MyAds'

const ErrorNotification = ({message, onClose, show}) => {
  return (
    <div className={`${BASE_CLASS}-notification`}>
      <MoleculeNotification
        autoClose={moleculeNotificationAutoClose.long}
        onClose={onClose}
        show={show}
        type={moleculeNotificationTypes.error}
      >
        {message}
      </MoleculeNotification>
    </div>
  )
}

ErrorNotification.displayName = 'ErrorNotification'

ErrorNotification.propTypes = {
  message: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired
}

export default ErrorNotification
